<template>
  <RadioInputList
    :id="$attrs.id || 'CitiesRadioList'"
    :key="$attrs.key || 'CitiesRadioList'"
    v-bind="$attrs"
    :title="$attrs.title || 'Escolha a cidade que você mora'"
    :options="$attrs.options || cptdCityList"
    :searchable="true"
    @input="$emit('input', $event)"
  />
</template>
<script>
import { mapGetters } from 'vuex'
import RadioInputList from '@/components/ui/newComponents/RadioInputList.vue'
export default {
  name: 'CitiesRadioList',
  components: {
    RadioInputList,
  },
  inheritAttrs: false,
  props: {
    state: { type: String, default: '' },
  },
  emits: ['input'],
  computed: {
    ...mapGetters({
      gtCities: 'services/address/gtCities',
    }),
    cptdCityList() {
      if (this.state && this.gtCities[this.state]) {
        return this.gtCities[this.state].map((ct) => ({
          label: ct.name,
          value: ct.value,
          id: ct.value,
        }))
      }

      return []
    },
  },
}
</script>
<style lang="scss"></style>
